import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Popover/popover';
import { css } from '@patternfly/react-styles';
export var PopoverContent = function PopoverContent(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? null : _a$className,
      children = _a.children,
      props = __rest(_a, ["className", "children"]);

  return React.createElement("div", Object.assign({
    className: css(styles.popoverContent, className)
  }, props), children);
};